"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./GoogleMaps.css");
var InfoWindow = (function (_super) {
    __extends(InfoWindow, _super);
    function InfoWindow(props) {
        var _this = _super.call(this, props) || this;
        _this._constructClass = _this._constructClass.bind(_this);
        _this._customizeEnums = _this._customizeEnums.bind(_this);
        _this._generateClasses = _this._generateClasses.bind(_this);
        return _this;
    }
    InfoWindow.prototype._generateClasses = function (size, color, weight, text) {
        var cssClasses = ['p-text'];
        cssClasses.push(this._constructClass(size, 'p-f-sz'));
        cssClasses.push(this._constructClass(color, 'p-t'));
        cssClasses.push(this._constructClass(weight, 'p-f-w'));
        if (text && text.indexOf(' ') < 0) {
            cssClasses.push('p-t-wr-fw');
        }
        return cssClasses.join(' ');
    };
    InfoWindow.prototype._constructClass = function (prop, prefix) {
        if (prop && prop !== 'None') {
            var customProp = this._customizeEnums(prop);
            return prefix + "-" + customProp;
        }
        else {
            return;
        }
    };
    InfoWindow.prototype._customizeEnums = function (en) {
        var cases = {
            'Xsmall': 'xs',
            'Small': 'sm',
            'Medium': 'md',
            'Large': 'lg',
            'Xlarge': 'xl',
            'Xlarge2': '2x',
            'Xlarge3': '3x',
            'Xlarge4': '4x',
            'Primary': 'Primary50',
            'Secondary': 'Secondary50',
            'Success': 'Success50',
            'Warning': 'Warning50',
            'Error': 'Error50',
            'Info': 'Info50',
            'Normal': 'n',
            'Bold': 'b'
        };
        return cases[en] ? cases[en].toLowerCase() : en.toLowerCase();
    };
    InfoWindow.prototype.render = function () {
        var _a = this.props, headerText = _a.headerText, subheaderText = _a.subheaderText, description = _a.description, isClickable = _a.isClickable, headerColor = _a.headerColor, headerSize = _a.headerSize, subheaderSize = _a.subheaderSize, descriptionSize = _a.descriptionSize;
        // header styles
        var hz = headerSize ? headerSize : 'Medium';
        var hc = headerColor ? headerColor : 'Primary';
        var hw = 'Bold';
        var headerCss = this._generateClasses(hz, hc, hw, headerText);
        // subheader styles
        var sz = subheaderSize ? subheaderSize : 'Medium';
        var sc = 'Default';
        var shw = 'Bold';
        var subheaderCss = this._generateClasses(sz, sc, shw, subheaderText);
        // description style
        var dz = descriptionSize ? descriptionSize : 'Small';
        var dc = 'Default';
        var dw = 'Normal';
        var descriptionCSS = this._generateClasses(dz, dc, dw, description);
        return (React.createElement("div", { className: "p-info-window" },
            React.createElement("div", { className: isClickable ? 'pointer' : '' },
                headerText &&
                    React.createElement("div", null,
                        React.createElement("span", { className: headerCss }, headerText),
                        React.createElement("br", null)),
                subheaderText &&
                    React.createElement("div", null,
                        React.createElement("span", { className: subheaderCss }, subheaderText),
                        React.createElement("br", null)),
                React.createElement("span", { className: descriptionCSS }, description))));
    };
    return InfoWindow;
}(React.Component));
InfoWindow.defaultProps = {
    description: '',
    isClickable: false,
    headerColor: 'Primary',
    headerText: '',
    subheaderText: '',
    headerSize: 'Medium',
    subheaderSize: 'Medium',
    descriptionSize: 'Small'
};
exports.default = InfoWindow;
//# sourceMappingURL=InfoWindow.js.map


//////////////////
// WEBPACK FOOTER
// ../player-google-maps/build/control/InfoWindow.js
// module id = 889
// module chunks = 0